import { render, staticRenderFns } from "./FavoriteProduct.vue?vue&type=template&id=3ebea436&scoped=true"
import script from "./FavoriteProduct.vue?vue&type=script&lang=js"
export * from "./FavoriteProduct.vue?vue&type=script&lang=js"
import style0 from "./FavoriteProduct.vue?vue&type=style&index=0&id=3ebea436&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebea436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ebea436')) {
      api.createRecord('3ebea436', component.options)
    } else {
      api.reload('3ebea436', component.options)
    }
    module.hot.accept("./FavoriteProduct.vue?vue&type=template&id=3ebea436&scoped=true", function () {
      api.rerender('3ebea436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/FavoriteProduct.vue"
export default component.exports